import React, { useMemo, useState, useEffect, useRef } from "react"
import "../../CenterAdmin/ManageStaff/ManageStaff.scss"
import { useHistory } from "react-router"
import { GlobalFilter } from "../../../frontDesk/patientDirectory/GlobalFilter"
import Modal from "react-bootstrap/Modal"
import Box from "@mui/material/Box"
import Row from "react-bootstrap/esm/Row"
import Col from "react-bootstrap/esm/Col"
import SurveyComponent from "../../../../pages/RMO/components/cancerTemplate/Template"
import defaultSurveyConfig from "../../../../pages/RMO/components/cancerTemplateForm/template"
import {
  getAllFormTemplatesByType, getConsentFormsById,
} from "../../../../core/services/api"
import { useTable, useSortBy, useGlobalFilter } from "react-table"
import { COLUMNS } from "./FormsAndTemplatesColumns"
import { useSelector } from "react-redux"

function ManageStaff() {
  const history = useHistory()
  const [data, setData] = useState([])
  const [show, setShow] = useState<boolean>(false)
  const [selectedJSON, setSelectedJSON] = useState<any>({})
  const [header, setHeader] = useState<string>("")
  const columns = useMemo(() => COLUMNS, [])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const componentRef = useRef()
  const readOnlys = useSelector((state: any) => state?.user?.readOnly)


  useEffect(() => {
    // setIsLoading(true)
    getAllFormTemplatesByType("CONSENT")
      .then((res: any) => {
        setData(res)
        setIsLoading(false)
      })
      .catch((err: any) => {
        console.log("Err", err)
        setIsLoading(false)
      })
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state
  /**
   * @param {any} path
   */

  const handleFormSelection = (rowData: any) => {
    const id: any = rowData?.original?.id
    if (id) {
      getConsentFormsById(id)
        .then((res: any) => {
          const jsonObj: any = res?.data[0]?.json
          const tempJson: any = jsonObj?.pages?.map((each: any) => {
            return { ...each, readOnly: true }
          })
          jsonObj["pages"] = tempJson
          setSelectedJSON(jsonObj)
          setHeader(rowData?.original?.name)
          setShow(true)
        })
        .catch((err: any) => {
          console.log(err?.message)
        })
    }
  }

  const handleClose = () => {
    setShow(false)
    setSelectedJSON({})
    setHeader("")
  }

  function ModalView() {
    return (
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col className="basic-patient-details">
                {header}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ width: "100%", marginTop: "20px" }}>
            {
              selectedJSON && (
                <div className="formsAndTemplates">
                  <SurveyComponent
                    css={defaultSurveyConfig.defaultSurveyCSS}
                    data={[]}
                    json={selectedJSON}
                    onComplete={(survey: any) => {
                      console.log(survey.data)

                      /** Save to a database */
                      /** Add to a spreadsheet, etc.... */
                    }}
                    hideDot={true}
                  />
                </div>
              )
            }
          </Box>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal >
    )
  }

  return (
    <div className="manage-staff-patients-container">
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="manage-staff-patients-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="manage-staff-text">Form Template</div>
      </div>

      <div className="manage-patients-container">
        <div className="manage-patients-container">
          <div className="row add-new">
            <div className="col-9"></div>
            <div className="col-3 add-new-text">
              {/* <Button
                className="button-container"
                onClick={() => history.push(`/addManageStaff`)}
              >
                Add New Staff
              </Button> */}
            </div>
            <div className="search-container">
              <div>
                <GlobalFilter
                  filter={globalFilter}
                  setFilter={setGlobalFilter}
                />
              </div>
              <div>
                {/* <Dropdown placeholder="All" selected="" option=""></Dropdown> */}
              </div>
            </div>
            <div>
              <table
                {...getTableProps()}
                // @ts-ignore
                ref={componentRef}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              paddingLeft: "40px",
                            }}
                          >
                            {column.render("Header")}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="border-radiusImportant"
                  {...getTableBodyProps()}
                >
                  {rows.map((row) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              onClick={() => {
                                if (readOnlys) return null
                                //Add code to open the form
                                handleFormSelection(row)
                              }}
                              style={{
                                maxWidth: "400px",
                                width: "400px",
                                wordWrap: "break-word",
                                maxHeight: "100px",
                                paddingLeft: "40px",
                                verticalAlign: "left",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "18px",
                                lineHeight: "24px",
                                letterSpacing: "1.35px",
                                textAlign: "initial",
                              }}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
                <tfoot>
                  {footerGroups.map((footerGroup) => (
                    <tr {...footerGroup.getFooterGroupProps()}>
                      {footerGroup.headers.map((column) => (
                        <td {...column.getFooterProps()}>
                          {column.render("Footer")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      {
        ModalView()
      }
    </div>
  )
}
export default ManageStaff
